import { render } from "./open-result.vue?vue&type=template&id=9f446184&scoped=true"
import script from "./open-result.vue?vue&type=script&lang=js"
export * from "./open-result.vue?vue&type=script&lang=js"

import "./open-result.vue?vue&type=style&index=0&id=9f446184&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9f446184"

export default script